import { css } from 'styled-components';

export const glassEffect = css`
  background: ${props => props.theme.cardBg};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid ${props => props.theme.cardBorder};
`;

// --- NEW: A REUSABLE CSS STRING FOR ALL FOLDER CARDS ---
export const baseCardCSS = css`
  /* The glass effect, defined directly using theme variables */
  background: ${({ theme }) => theme.cardBg};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid ${({ theme }) => theme.cardBorder};

  /* Layout and transition styles */
  display: block;
  border-radius: 12px;
  padding: 20px;
  text-decoration: none;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border-color 0.2s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const lightTheme = {
  body: '#E0E5F0',
  bodyGradient: 'radial-gradient(at 0% 0%, #d4e0ff 0, transparent 50%), radial-gradient(at 100% 0%, #ffc5d4 0, transparent 50%)',
  text: '#394257',
  heading: '#000000',
  cardBg: 'rgba(255, 255, 255, 0.45)',
  cardBorder: 'rgba(255, 255, 255, 0.2)',
  navBg: 'rgba(240, 242, 245, 0.5)',
  navText: '#394257',
  navTextActive: '#000000',
  navActiveBg: 'rgba(255, 255, 255, 0.8)',
  inputBg: 'rgba(255, 255, 255, 0.5)',
  primary: '#007AFF',
  accordionBg: 'rgba(255, 255, 255, 0.3)',
};

export const darkTheme = {
  body: '#0E1117',
  bodyGradient: 'radial-gradient(at 0% 100%, #192c4e 0, transparent 50%), radial-gradient(at 100% 0%, #3a193b 0, transparent 50%)',
  text: '#c9d1d9',
  heading: '#FFFFFF',
  cardBg: 'rgba(38, 41, 48, 0.34)',      // More opaque and slightly lighter background for cards
  cardBorder: 'rgba(255, 255, 255, 0.05)',// A more visible border to define the edge
  accordionBg: 'rgba(28, 28, 30, 0.65)',  // Kept the accordions darker for visual hierarchy
  navBg: 'rgba(44, 46, 51, 0.5)',
  navText: '#8b949e',
  navTextActive: '#FFFFFF',
  navActiveBg: 'rgba(44, 44, 46, 0.8)',
  inputBg: 'rgba(28, 28, 30, 0.9)',
  primary: '#0A84FF',
};